module.exports = __webpack_public_path__ + "img/why-back.c9d4780a.jpg";